import { useAppSelector } from "app/hooks";
import { selectCurrentUser } from "features/auth/auth-slice";
import { useDismissibleBanner } from "hooks/use-dismissible-banner.hook";

export const SIDE_MENU_EXPAND_HINT_STORAGE_KEY =
  "suno_side_menu_expand_hint_v1_";

/**
 * Whether this person still gets the one-time "how to get the names back" card.
 * Mount it only inside the rail: the banner hook reads its state once, on mount,
 * so the card appears the first time someone is in the rail and never again once
 * they press Got it or expand the menu.
 */
export function useSideMenuExpandHint() {
  const userId = useAppSelector(selectCurrentUser)?.id;
  return useDismissibleBanner({
    storageKey: SIDE_MENU_EXPAND_HINT_STORAGE_KEY,
    userId: String(userId ?? ""),
    enabled: userId !== undefined && userId !== null,
    datadogActions: {
      shown: "side_menu_expand_hint_shown",
      dismissed: "side_menu_expand_hint_dismissed"
    }
  });
}
